<template>
    <a-modal
        centered
        :visible="visible"
        title="添加快递信息"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="order-express" :rules="rules">
            <a-form-model-item label="收件地址" prop="address">
                <a-textarea v-model="form.address"></a-textarea>
            </a-form-model-item>
          <a-form-model-item label="收件人" prop="userName">
            <a-input v-model="form.userName"></a-input>
          </a-form-model-item>
          <a-form-model-item label="联系方式" prop="mobile">
            <a-input v-model="form.mobile"></a-input>
          </a-form-model-item>
          <a-form-model-item label="快递单号" prop="express">
            <a-input v-model="form.express"></a-input>
          </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
      address: null,
      userName: null,
      mobile: null,
      express: null,
      order_no: null,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            callback: null,
        },
        data() {
            return {
                submitting: false,
                rules: {
                  address: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                  userName: [
                    {
                      required: true,
                      trigger: ["change", "blur"],
                      message: "必填",
                    },
                  ],
                  mobile: [
                    {
                      required: true,
                      trigger: ["change", "blur"],
                      message: "必填",
                    },
                  ],
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    Object.keys(this.form).map((v) => {
                        if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                            this.form[v] = this.record[v];
                        }
                    });
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["order-express"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.form.type = "confirm";

                        this.$http
                            .put("/order_trademark/express/" + this.record.order_no, this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                    this.$message.success(res.message);

                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({ title: "失败", centered: true, content: res.message });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },

            after_close() {
                this.$refs["order-express"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
        },
    };
</script>
